/** Summarize takeoff usage counts for display (e.g. merge table Usage column). */
export function formatTakeoffUsageSummary(takeoffUsages: ReadonlyArray<{ __typename?: string }>): string | undefined {
  const planPackages = takeoffUsages.count((rp) => rp.__typename === "PlanPackage");
  const designPackages = takeoffUsages.count((rp) => rp.__typename === "DesignPackage");
  const productOfferings = takeoffUsages.count((rp) => rp.__typename === "ProductOffering");

  const parts = [
    planPackages > 0 ? `${planPackages} Takeoff${planPackages === 1 ? "" : "s"}` : undefined,
    designPackages > 0 ? `${designPackages} Design Package${designPackages === 1 ? "" : "s"}` : undefined,
    productOfferings > 0 ? `${productOfferings} Product Offering${productOfferings === 1 ? "" : "s"}` : undefined,
  ].compact();

  if (parts.isEmpty) return undefined;
  return `Used in ${parts.join(", ")}`;
}
